<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>Particularly for Charles and Jimmy Parr</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3c39f093